import { ErrorCard } from '#/shared/components/ErrorCard';
import { Container } from '#/shared/components/layout/Container';

export function ForwardSuccessScreen() {
  return (
    <Container className="flex flex-1 flex-col items-center justify-center space-y-4">
      <ErrorCard
        title="Request forwarded"
        description="Thank you for forwarding this approval request to the appropriate approver. We've notified the requestor to ensure that future requests are sent to the right person."
      />
    </Container>
  );
}
